import { render, staticRenderFns } from "./CategoriesNavigation.vue?vue&type=template&id=03583874&"
import script from "./CategoriesNavigation.vue?vue&type=script&lang=js&"
export * from "./CategoriesNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports